export default {
      id: "car-l-side-usage",
      viewBox: "0 0 112 33",
      url: __webpack_public_path__ + "img/icons.svg#car-l-side",
      toString: function () {
        return this.url;
      }
    }